// 文件处理相关
import intersection from 'lodash/intersection';
import { withDynamicCdn } from './dynamic-cdn';

export const IMAGE_FILE_TYPES = [
    'image/*',
    'image/gif',
    'image/jpeg',
    'image/png',
    'image/svg+xml',
    'image/x-icon',
    '.gif',
    '.jpg',
    '.jpeg',
    '.png',
    '.tiff',
    '.webp',
];

export const onlyAcceptImage = accept => {
    if (typeof accept !== 'string') {
        return false;
    }
    accept = accept.trim();
    if (!accept) {
        return false;
    }
    const acceptFileTypes = accept.split(',')
        .map(type => type.trim().toLowerCase())
        .filter(type => type);
    const acceptImageFileType = intersection(acceptFileTypes, IMAGE_FILE_TYPES);
    if (acceptFileTypes.length === acceptImageFileType.length) {
        return true;
    }
    return false;
};

export function base64ToFile({ base64, fileType }) {
    const bytes = window.atob(base64);
    const ab = new ArrayBuffer(bytes.length);
    const ia = new Uint8Array(ab);

    for (let i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i);
    }
    const type = fileType === 'jpg' ? 'jpeg' : fileType;
    const blobFile = new Blob([ab], { type: 'image/' + type });
    blobFile.lastModifiedDate = new Date();
    blobFile.name = `img_${new Date()}.${type || 'jpg'}`;
    return new File([blobFile], blobFile.name, { type: 'image/' + type, lastModified: Date.now() });
}

export const isIOS = () => {
    const ua = typeof window !== 'undefined' ? navigator.userAgent : '';
    return !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
};

export const UPLOAD_FILE_PLACEHOLDER_SRC = withDynamicCdn('udata/pkg/fe/file.png');